import { Avatar, AvatarFallback } from '@mint-lib/tw-components';

import { getNodeCreator } from '../../../../../helpers/knowledge-base/fileSystemNode.js';
import { toUserName } from '../../../../../helpers/knowledge-base/userName.js';
import type { FileSystemNode } from '../../../../../types/fileSystem.js';

type CreatorCellProps = {
  node?: FileSystemNode;
};

const CreatorCell = ({ node }: CreatorCellProps) => {
  const creator = node && getNodeCreator(node);

  if (!creator) return null;

  const name = toUserName(creator);

  if (!name) return null;

  return (
    <div className="flex h-full items-center" title={name} aria-label={name}>
      <Avatar size="small">
        <AvatarFallback
          firstName={creator.firstName ?? undefined}
          lastName={creator.lastName ?? undefined}
        />
      </Avatar>
    </div>
  );
};

export { CreatorCell };
